import CustomLayout from "./wrapPageElement"
import "@fontsource/fira-code"
import "./src/styles/prism-monokai.css"
import "prismjs/plugins/line-numbers/prism-line-numbers.css"
import "katex/dist/katex.min.css"

export const wrapPageElement = CustomLayout
